/**
 * Число очков с разделёнными разрядами: `4200` → `4 200`.
 *
 * Разряды группируются регуляркой, а не `toLocaleString`: инвариант
 * `locale-time` запрещает локальное форматирование вне этого модуля
 * (он заточен под даты, но паттерн широкий), а результат `toLocaleString`
 * ещё и зависит от набора локалей в раннере — в CI он отличался бы
 * от браузерного.
 */
export function formatScore(value: number): string {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/**
 * Русская форма существительного при числе: 1 очко, 2 очка, 5 очков.
 *
 * Нужна подписям Карьеры, где число приходит из данных: пороги и номиналы
 * правятся деплоем, и «1 очков» вылезло бы ровно тогда, когда кто-то
 * поставит порог в единицу. `Intl.PluralRules` не берём по той же причине,
 * что и в `formatScore`: инвариант `locale-time` и зависимость от набора
 * локалей в раннере.
 */
export function plural(
  value: number,
  one: string,
  few: string,
  many: string,
): string {
  const mod100 = Math.abs(value) % 100;
  // 11–14 — исключение: «одиннадцать очков», а не «очко»
  if (mod100 >= 11 && mod100 <= 14) return many;

  const mod10 = mod100 % 10;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}
